const cards = [
    {
        id: 'leaveApplication',
        title: 'Написать заявление на отпуск',
        style: 'orange'
    },
    {
        id: 'datesAgreement',
        title: 'Согласовать даты отпуска с руководителем',
        style: 'blue',
    },
    {
        id: 'managerSignature',
        title: 'Подписать заявление у руководителя',
        style: 'blue'
    },
    {
        id: 'colleaguesVacations',
        title: 'Уточнить у коллег даты их отпусков',
        style: 'purple'
    },
    {
        id: 'hrDepartment',
        title: 'Отправить заявление в HR-отдел',
        style: 'blue'
    },
    {
        id: 'vacationSchedule',
        title: 'Посмотреть график отпусков',
        style: 'orange'
    },
    {
        id: 'colleagueAgree',
        title: 'Договориться с коллегой, чтобы он перенёс свой отпуск',
        style: 'purple'
    },
    {
        id:'rewriteApplication',
        title: 'Переписать заявление',
        style: 'purple'
    },
    {
        id: 'managerAdditionalVacationsAgree',
        title: 'Согласовать дополнительный отпуск с руководителем',
        style: 'blue'
    },
    {
        id: 'findSignatureOfAnotherManager',
        title: 'Узнать, кто замещает руководителя',
        style: 'orange'
    },
    {
        id: 'dismissal',
        title: 'Написать заявление на увольнение',
        style: 'purple'
    },
    {
        id: 'managerArbiting',
        title: 'Пойти к руководителю, чтобы он решил, кто идёт в отпуск',
        style: 'orange'
    }
]

export default cards